/* eslint-disable */
import "react-toastify/dist/ReactToastify.css";
import { useEffect, useState } from "react";
import * as Yup from "yup";
import VisibilityIcon from "@mui/icons-material/Visibility";
import VisibilityOffIcon from "@mui/icons-material/VisibilityOff";
import { toast, ToastContainer } from "react-toastify";
import { Grid, Typography, MenuItem, Box, Avatar, Button, CircularProgress, InputAdornment, styled, Card, useTheme, Tooltip, IconButton } from "@mui/material";
import { useDispatch, useSelector } from "react-redux";
import { useMutation } from "@apollo/client";
import { useNavigate } from "react-router";
import ContentCopyIcon from "@mui/icons-material/ContentCopy";
import CustomTextField from "../dashboards/forms/theme-elements/CustomTextField";
import CustomFormLabel from "../dashboards/forms/theme-elements/CustomFormLabel";
import CustomSelect from "../dashboards/forms/theme-elements/CustomSelect";
import { validateContact, validateString, regexPassword, validateName } from "../../utils/validations";
import { UpdateUser, changPassword } from "../../gql/mutations/auth";
import { usePopup } from "../../context/commonPop";
import { logoutUser, updateImage, updateUser } from "../../redux/action";
import useQuery from "../../hooks/allQuery";
import { updateImageProfile } from "../../gql/mutations/profileImage";
import SetPasswordGoogle from "./SetPasswordGoogle";
import defultUserImg from "../../Images/profile/user-1.jpg";
import countryCode from "../../utils/countryCode.json";
import countryCurrencyCode from "../../utils/countryCurrencyCode.json";
import CameraIcon from "../SvgIcons/CameraIcon";
import ProfileImageModal from "./modal/ProfileImageModal";
import { deleteSession } from "../../utils/session";

const BoxWrapper = styled(Box)(({ theme }) => ({
  padding: "16px",

  "& .AccountProfile": {
    "& .MainHeading": {
      color: theme.palette.mode === "dark" ? "#ffffff" : "#2A3547",
      fontSize: "20px",
      fontWeight: 700,
      lineHeight: 1,
      marginBottom: "12px",
    },
    "& .SubHeading": {
      color: theme.palette.mode === "dark" ? "#ffffff" : "#2A3547",
      fontSize: "14px",
      fontWeight: 400,
      lineHeight: 1.5,
      marginBottom: "30px",
    },
    "& .ProfileImgWrapper": {
      marginBottom: "30px",
      "& .ProfileAvatarWrapper": {
        width: 100,
        height: 100,
        position: "relative",
        "& .MuiAvatar-root": {
          width: 100,
          height: 100,
          border: `2px solid ${theme.palette.primary.main}`,
          cursor: "pointer",
        },
        "& .UploadBtn": {
          minWidth: "auto",
          padding: "0",
          width: "30px",
          height: "30px",
          borderRadius: "100px",
          position: "absolute",
          bottom: "0",
          right: "0",
          "& .LoaderWrapper": {
            color: "#ffffff",
          },
        },
      },
      "& .FileUploadError": {
        color: "red",
        fontSize: "14px",
        fontWeight: 500,
        lineHeight: 1.5,
        marginTop: "10px",
      },
    },
    "& .FormWrapper": {
      "& form": {
        marginBottom: "0px",
        "& label": {
          color: theme.palette.mode === "dark" ? "#ffffff" : "#2A3547",
          fontSize: "14px",
          fontWeight: 500,
          lineHeight: 1,
          marginTop: "0px",
          marginBottom: "7px",
        },
        "& p.MuiFormHelperText-root": {
          position: "absolute",
          top: "45px",
          left: "0",
          lineHeight: 1.1,
          marginLeft: "2px",
          marginRight: "0",
        },
        "& .InputStyleFiled": {
          "& .copyClip": {
            backgroundColor: theme.palette.primary.main,
            color: "#fff",
            position: "absolute",
            right: "10px",
            top: "50%",
            transform: "translateY(-50%)",
            padding: "5px",
            "&:hover": {
              backgroundColor: theme.palette.primary.dark,
            },
            "&:focus": {
              outline: "none",
            },
            "& svg": {
              fill: "#fff",
              width: "20px",
              height: "20px",
            },
          },
        },
        "& .UpdateBtnWrapper": {
          display: "flex",
          justifyContent: "flex-end",
          alignItems: "flex-end",
          height: "100%",
          width: "100%",
          paddingTop: "16px",
          "& button": {
            "&:focus": {
              outline: "none",
            },
          },
        },
      },
    },
  },
  "& .ChangePassword": {
    "& .MainHeading": {
      color: theme.palette.mode === "dark" ? "#ffffff" : "#2A3547",
      fontSize: "20px",
      fontWeight: 700,
      lineHeight: 1,
      marginBottom: "12px",
    },
    "& .SubHeading": {
      color: theme.palette.mode === "dark" ? "#ffffff" : "#2A3547",
      fontSize: "14px",
      fontWeight: 400,
      lineHeight: 1.5,
      marginBottom: "30px",
    },
    "& .FormWrapper": {
      "& form": {
        marginBottom: "0px",
        "& label": {
          color: theme.palette.mode === "dark" ? "#ffffff" : "#2A3547",
          fontSize: "14px",
          fontWeight: 500,
          lineHeight: 1,
          marginTop: "0px",
          marginBottom: "7px",
        },

        "& p.MuiFormHelperText-root": {
          position: "absolute",
          top: "45px",
          left: "0",
          lineHeight: 1.1,
        },
        "& .UpdateBtnWrapper": {
          display: "flex",
          justifyContent: "flex-end",
          alignItems: "flex-end",
          height: "100%",
        },
      },
    },
  },
}));

// profileData
const profileData = {
  name: "",
  address: "",
  phone: "",
  location: "India",
  currency: "India",
  country_phone_code: "91",
};

// errorObj
const errorObj = {
  name: false,
  phone: false,
  location: false,
  currency: false,
  country_phone_code: false,
};

function AccountTab() {
  const theme = useTheme();
  const [loading, setLoading] = useState(false);
  const [formData, setFormData] = useState(profileData);
  const [errorClass, setErrorClass] = useState(errorObj);
  const [errorMsg, setErrorMsg] = useState("");
  const [isUploading, setIsUploading] = useState(false);
  const [isUploadError, setIsUploadError] = useState(false);
  const [profileImageOpen, setProfileImageOpen] = useState(false);
  const [isFormChanged, setIsFormChanged] = useState(false);
  const handleCopy = () => {
    navigator.clipboard.writeText(formData.email).then(() => {
      toast.success("Email copied to clipboard!", {
        position: "top-right",
        autoClose: 2000,
        hideProgressBar: false,
        closeOnClick: true,
        pauseOnHover: true,
        draggable: true,
        progress: undefined,
        theme: "colored",
      });
    });
  };

  const handleProfileImage = () => {
    setProfileImageOpen(!profileImageOpen);
  };

  const { handleOpen } = usePopup();
  const [UPGRADEUSER] = useMutation(UpdateUser);
  const [UPDATEPROFILEIMAGE] = useMutation(updateImageProfile);
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const { allQuery } = useQuery();
  const userData = useSelector(state => state.reducer.userData);
  const checkError1 = async data => {
    const countryCode = data?.country_phone_code;
    const name = validateName(data.name);
    const phone = validateContact(data.phone, countryCode);
    const location = validateString(data.location);
    const currency = validateString(data.currency);
    const country_phone_code = validateString(data.country_phone_code);
    const address = validateString(data.address);

    setErrorClass({
      ...errorClass,
      name,
      phone,
      location,
      currency,
      country_phone_code,
      address,
    });

    if (name || phone) {
      return true;
    }
    return false;
  };

  const handleSaveClick = async e => {
    e.preventDefault();
    setLoading(true);
    try {
      const check = await checkError1(formData, profileData);

      if (check) {
        setLoading(false);

        return;
      }
      allQuery({
        QUERY: UPGRADEUSER,
        variables: {
          data: {
            id: userData.id,
            name: formData.name,
            address: formData.address,
            phone: formData.phone,
            country_phone_code: formData.country_phone_code,
            country_currency: formData.currency,
            location: formData.location,
          },
        },

        onCompleteFunc: dataDis => {
          navigate("/account-settings");
          dispatch(updateUser(dataDis.updateUser));
          setLoading(false);
          toast.success("Profile updated successfully!");
        },
        onErrorFunc: errdata => {
          handleOpen(true, errdata.message);
          setLoading(false);
          toast.error(errdata.message);
        },
      });
    } catch {
      console.log(" Not update");
      setLoading(false);
    }
  };

  const handleUpdateProfileImage = async base64ImageData => {
    if (!base64ImageData) {
      return;
    }
    const mimeTypeMatch = base64ImageData.match(/^data:([A-Za-z-+\/]+);base64/);
    if (!mimeTypeMatch) {
      console.error("Unable to extract file type from base64ImageData");
      return;
    }
    setIsUploading(true);

    const mimeType = mimeTypeMatch[1];
    const [_, fileExtension] = mimeType.split("/");
    try {
      const response = await UPDATEPROFILEIMAGE({
        variables: {
          profileImageInput: {
            userId: userData.id,
            imageData: base64ImageData,
            fileType: fileExtension,
          },
        },
      });
      const imageData = response.data.uploadProfileImage.imageUrl;

      dispatch(updateImage({ imageUrl: imageData }));
      setIsUploading(false);
    } catch (error) {
      // Handle errors here
      console.error("Error updating profile image:", error);
      setIsUploading(false);
    }
  };

  const isFormValid = () => {
    const selectedCountryCode = formData?.country_phone_code || profileData.country_phone_code;
    const result = countryCode.find(entry => entry.phone === selectedCountryCode);
    if (!result) return false;
    const validLengths = Array.isArray(result.phoneLength) ? result.phoneLength : [result.phoneLength];

    return (
      formData.name.trim() !== "" &&
      /^[A-Za-z\s]+$/.test(formData.name) &&
      formData.phone.trim() !== "" &&
      validLengths.includes(formData.phone.length) &&
      Object.values(errorClass).every(val => !val)
    );
  };

  useEffect(() => {
    setFormData({
      name: userData?.name || "",
      address: userData?.address || "",
      phone: userData?.phone || "",
      address: userData.address || "",
      location: userData?.location || "",
      currency: userData?.country_currency,
      country_phone_code: userData?.country_phone_code,
      email: userData?.email,
    });
  }, [userData]);

  useEffect(() => {
    if (formData.location) {
      const selectedCountry = countryCurrencyCode.find(country => country.country === formData.location);

      if (selectedCountry) {
        setFormData(prevData => ({
          ...prevData,
          currency: `${selectedCountry.country} (${selectedCountry.currency_code})`,
        }));
      }
    }
  }, [formData.location]);
  useEffect(() => {
    const isChanged =
      formData.name !== userData?.name ||
      formData.address !== userData?.address ||
      formData.phone !== userData?.phone ||
      formData.location !== userData?.location ||
      formData.currency !== userData?.country_currency ||
      formData.country_phone_code !== userData?.country_phone_code;

    setIsFormChanged(isChanged);
  }, [formData, userData]);

  return (
    <BoxWrapper>
      <Card sx={{ padding: "22px 24px 30px 24px", border: `1px solid ${theme.palette.divider}`, boxShadow: "none !important", mb: "16px" }} className="AccountProfile">
        <Typography component="h5" className="MainHeading">
          Account Profile
        </Typography>
        <Typography component="p" className="SubHeading">
          You can change profile picture and edit profile details
        </Typography>
        <Box className="ProfileImgWrapper">
          <Box className="ProfileAvatarWrapper">
            <Tooltip title="Click to Expand" placement="top">
              <Avatar src={userData?.imageUrl || defultUserImg} alt="user1" onClick={handleProfileImage} />
            </Tooltip>
            <Tooltip title="Click to Upload">
              <Button variant="contained" color="primary" className="UploadBtn" component="label" title="Upload Image">
                {isUploading ? <CircularProgress size={15} thickness={5} className="LoaderWrapper" /> : <CameraIcon />}
                <input
                  hidden
                  accept="image/*"
                  type="file"
                  onChange={e => {
                    const file = e.target.files[0];
                    if (file) {
                      if (file.size > 5242880) {
                        e.target.value = "";
                        setIsUploadError(true);
                        return;
                      }
                      const reader = new FileReader();
                      reader.onload = event => {
                        const base64ImageData = event.target.result;
                        handleUpdateProfileImage(base64ImageData);
                      };
                      reader.readAsDataURL(file);
                      setIsUploadError(false);
                    }
                  }}
                />
              </Button>
            </Tooltip>
            <ProfileImageModal profileImage={userData?.imageUrl || defultUserImg} open={profileImageOpen} handleClose={handleProfileImage} />
          </Box>
          {isUploadError && (
            <Typography component="p" className="FileUploadError">
              FILE SIZE IS TOO LARGE!
              <br />
              Allowed JPG, GIF or PNG. Max size of 5MB
            </Typography>
          )}
        </Box>
        <Box className="FormWrapper">
          <form>
            <Grid container spacing={3}>
              <Grid item xs={12} sm={6} md={4}>
                <CustomFormLabel htmlFor="text-name">
                  Your Name <span style={{ color: "red" }}>*</span>
                </CustomFormLabel>
                <CustomTextField
                  id="text-name"
                  name="name"
                  value={formData.name}
                  placeholder="Your Name"
                  onChange={e => {
                    let value = e.target.value;
                    value = value.trimStart().replace(/\s+/g, " ");
                    if (!value) {
                      setErrorClass(prev => ({ ...prev, name: "Please enter a name" }));
                    } else if (!/^[A-Za-z\s]+$/.test(value)) {
                      setErrorClass(prev => ({ ...prev, name: "Only letters are allowed" }));
                    } else {
                      setErrorClass(prev => ({ ...prev, name: "" }));
                    }
                    setFormData({ ...formData, name: value });
                  }}
                  onBlur={() => {
                    setFormData(prev => ({ ...prev, name: prev.name.trim() }));
                    if (!formData.name.trim()) {
                      setErrorClass(prev => ({ ...prev, name: "Please enter a name" }));
                    }
                  }}
                  className="InputStyleFiled"
                  fullWidth
                  error={Boolean(errorClass.name)}
                  helperText={errorClass.name}
                />
              </Grid>
              <Grid item xs={12} sm={6} md={4}>
                <CustomFormLabel htmlFor="text-phone">
                  Phone <span style={{ color: "red" }}>*</span>
                </CustomFormLabel>
                <Box sx={{ display: "flex", alignItems: "flex-start", gap: "5px" }}>
                  <CustomSelect
                    id="country-code"
                    variant="outlined"
                    value={formData?.country_phone_code || profileData.country_phone_code}
                    onChange={e => setFormData({ ...formData, country_phone_code: e.target.value })}
                  >
                    {countryCode.map(option => (
                      <MenuItem key={option.label} value={option.phone}>
                        {option.label} (+{option.phone})
                      </MenuItem>
                    ))}
                  </CustomSelect>

                  <CustomTextField
                    id="text-phone"
                    name="phone"
                    type="text"
                    placeholder="Your Phone Number"
                    onChange={e => {
                      let value = e.target.value.replace(/\D/g, "");
                      const selectedCountryCode = formData?.country_phone_code || profileData.country_phone_code;
                      const result = countryCode.find(entry => entry.phone === selectedCountryCode);
                      const validLengths = Array.isArray(result.phoneLength) ? result.phoneLength : [result.phoneLength];
                      const maxLength = Math.max(...validLengths);

                      if (value.length > maxLength) {
                        value = value.slice(0, maxLength);
                      }

                      let isValid = true;
                      let errorMsg = "";

                      if (value.length < maxLength) {
                        isValid = false;
                        errorMsg = `Phone number must be ${maxLength} digits.`;
                      } else if (selectedCountryCode === "91" && /^[012345]/.test(value)) {
                        isValid = false;
                        errorMsg = "Please provide a valid Indian phone number.";
                      }
                      setFormData({ ...formData, phone: value });
                      setErrorClass({ ...errorClass, phone: !isValid });
                      setErrorMsg(errorMsg);
                    }}
                    className="InputStyleFiled"
                    value={formData.phone}
                    fullWidth
                    error={errorClass.phone}
                    helperText={errorClass.phone ? errorMsg : ""}
                  />
                </Box>
              </Grid>

              <Grid item xs={12} sm={6} md={4}>
                <CustomFormLabel htmlFor="text-address">
                  Email <span style={{ color: "red" }}>*</span>
                </CustomFormLabel>
                <Box className="InputStyleFiled" sx={{ position: "relative" }}>
                  <CustomTextField
                    id="text-address"
                    name="email"
                    disabled
                    value={formData.email}
                    sx={{
                      "& .MuiInputBase-root .Mui-disabled": {
                        WebkitTextFillColor: theme.palette.mode === "dark" ? "#ffffff54" : "rgb(0 0 0 / 54%) !important",
                      },
                    }}
                    fullWidth
                  />
                  <Tooltip title="Copy Email">
                    <IconButton onClick={handleCopy} className="copyClip" onFocus={e => e.target.blur()}>
                      <ContentCopyIcon />
                    </IconButton>
                  </Tooltip>
                </Box>
              </Grid>
              <Grid item xs={12} sm={6} md={4}>
                <CustomFormLabel htmlFor="text-address">Address</CustomFormLabel>
                <CustomTextField
                  id="text-address"
                  name="address"
                  placeholder="Your Address"
                  value={formData.address}
                  onChange={e => setFormData({ ...formData, address: e.target.value })}
                  className="InputStyleFiled"
                  fullWidth
                />
              </Grid>
              <Grid item xs={12} sm={6} md={4}>
                <CustomFormLabel htmlFor="text-location">Country</CustomFormLabel>
                <CustomSelect
                  fullWidth
                  id="text-location"
                  variant="outlined"
                  value={formData?.location || profileData.location}
                  onChange={e => setFormData({ ...formData, location: e.target.value })}
                >
                  {countryCode
                    .sort((a, b) => a.label.localeCompare(b.label))
                    .map(option => (
                      <MenuItem
                        key={option.label}
                        value={option.label}
                        sx={{
                          "&.Mui-selected": {
                            backgroundColor: theme.palette.primary.main,
                            color: "#fff",
                          },
                        }}
                      >
                        {option.label}
                      </MenuItem>
                    ))}
                </CustomSelect>
              </Grid>
              <Grid item xs={12} sm={6} md={4}>
                <CustomFormLabel htmlFor="text-currency">Currency</CustomFormLabel>
                <CustomSelect fullWidth id="text-currency" variant="outlined" value={formData.currency} onChange={e => setFormData({ ...formData, currency: e.target.value })}>
                  {countryCurrencyCode
                    .sort((a, b) => a.country.localeCompare(b.country))
                    .map(option => (
                      <MenuItem
                        key={option.currency_code + option.country}
                        value={`${option.country} (${option.currency_code})`}
                        sx={{
                          "&.Mui-selected": {
                            backgroundColor: theme.palette.primary.main,
                            color: "#fff",
                          },
                        }}
                      >
                        {`${option.country} (${option.currency_code})`}
                      </MenuItem>
                    ))}
                </CustomSelect>
              </Grid>
              <Box className="UpdateBtnWrapper">
                <Button onClick={handleSaveClick} variant="contained" color="primary" disabled={loading || !isFormValid() || !isFormChanged} sx={{ minWidth: "80px" }}>
                  {loading ? <CircularProgress size={25} /> : "Update"}
                </Button>
              </Box>
            </Grid>
          </form>
        </Box>
      </Card>
      <Card sx={{ padding: "22px 24px 30px 24px", border: `1px solid ${theme.palette.divider}`, boxShadow: "none !important" }} className="ChangePassword">
        <Typography component="h5" className="MainHeading">
          {userData?.googlePassword ? "Change Password" : "Set Password"}
        </Typography>
        <Typography component="p" className="SubHeading">
          {userData?.googlePassword && userData?.isGoogleAuth
            ? "You logged in through Google Login. You can update a new password here. To update your password please confirm here."
            : userData?.googlePassword && !userData?.isGoogleAuth
            ? "To change your password please confirm here"
            : !userData?.googlePassword && userData?.isGoogleAuth
            ? "You logged in through Google Login. You can create a new password here. To create your password please confirm here."
            : !userData?.googlePassword && !userData?.isGoogleAuth
            ? "To change your password please confirm here"
            : ""}
        </Typography>
        {userData?.googlePassword ? <ChangePassword /> : <SetPasswordGoogle />}
      </Card>
    </BoxWrapper>
  );
}

export default AccountTab;

function ChangePassword() {
  const [err, setErr] = useState("");
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const [errorState, setErrorState] = useState({
    newpassword: false,
    repeatpassword: false,
  });
  const [values, setValues] = useState({
    oldpassword: "",
    newpassword: "",
    repeatpassword: "",
  });
  const [visibility, setVisibility] = useState({
    oldpassword: false,
    newpassword: false,
    repeatpassword: false,
  });
  const [PASSDATA] = useMutation(changPassword);
  const { allQuery } = useQuery();
  const { handleOpen } = usePopup();
  const userData = useSelector(state => state.reducer.userData);

  const yupSchema = Yup.object({
    oldpassword: Yup.string().required("Old password is required"),
    newpassword: Yup.string()
      .matches(regexPassword, "Password must contain at least one uppercase letter, one lowercase letter, one digit, one special character, and be 8-15 characters long")
      .required("Password is required")
      .min(8, "Password must be at least 8 characters long")
      .max(15, "Password must be at most 15 characters long"),
    repeatpassword: Yup.string()
      .required("Confirm Password is required")
      .oneOf([Yup.ref("newpassword"), null], "Passwords must match"),
  });

  function onhandlechange(e) {
    const { name, value } = e.target;

    setValues(prevValues => ({
      ...prevValues,
      [name]: value,
    }));

    setErr(null);

    yupSchema
      .validateAt(name, { ...values, [name]: value })
      .then(() => {
        setErrorState(prevErrors => ({
          ...prevErrors,
          [name]: false,
        }));
      })
      .catch(validationError => {
        setErrorState(prevErrors => ({
          ...prevErrors,
          [name]: validationError.message,
        }));
      });
  }

  async function checkError() {
    try {
      const data = await yupSchema.validate(values, { abortEarly: false });
      setErrorState({});
      return data;
    } catch (validationErrors) {
      const newErrors = {};
      validationErrors.inner.forEach(error => {
        newErrors[error.path] = error.message;
      });
      setErrorState(newErrors);
      return null;
    }
  }

  async function handleclick() {
    const errors = {};

    if (Object.keys(errors).length > 0) {
      setErrorState(errors);
      return;
    }

    if (values.oldpassword === values.newpassword) {
      errors.newpassword = "Old password and new password must be different.";
      setErrorState(errors);
      return;
    }

    setErrorState({});

    const check = await checkError();
    if (check) {
      setErr(null);
      allQuery({
        QUERY: PASSDATA,
        variables: {
          data: {
            newPassword: values.newpassword,
            oldPassword: values.oldpassword,
            userId: userData.id,
          },
        },
        onCompleteFunc: async () => {
          let countdown = 4;

          const toastId = toast.success(`Password changed successfully!`, {
            position: "top-right",
            autoClose: false,
            hideProgressBar: false,
            closeOnClick: false,
            pauseOnHover: false,
            draggable: false,
            theme: "colored",
          });

          const interval = setInterval(() => {
            if (countdown > 0) {
              setTimeout(() => {
                countdown--;

                toast.update(toastId, {
                  render: `You will be logged out in ${countdown}... seconds(s)`,
                });
              }, 1500);
            } else {
              clearInterval(interval);
              toast.dismiss(toastId);

              setTimeout(() => {
                toast.success("Please log in using your new credentials.", {
                  position: "top-right",
                  autoClose: 3000,
                  hideProgressBar: false,
                  closeOnClick: true,
                  pauseOnHover: true,
                  draggable: true,
                  theme: "colored",
                });
              }, 1000);

              dispatch(logoutUser(true));
              deleteSession();
              navigate("/");
            }
          }, 1000);

          setValues({
            oldpassword: "",
            newpassword: "",
            repeatpassword: "",
          });
          setErr(null);
        },
        onErrorFunc: errdata => {
          setErr(errdata.message);
        },
      });
    }
  }
  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);
  return (
    <Box className="FormWrapper">
      <ToastContainer />
      <form>
        <Grid container spacing={3.5}>
          <Grid item xs={12}>
            <CustomFormLabel htmlFor="text-cpwd">Current Password</CustomFormLabel>
            <CustomTextField
              id="text-cpwd"
              placeholder="Current Password"
              onChange={onhandlechange}
              variant="outlined"
              fullWidth
              name="oldpassword"
              type={visibility.oldpassword ? "text" : "password"}
              value={values.oldpassword}
              error={errorState.oldpassword}
              helperText={errorState.oldpassword}
              InputProps={{
                endAdornment: (
                  <InputAdornment position="end">
                    <IconButton
                      sx={{
                        "&:focus": {
                          outline: "none",
                        },
                      }}
                      aria-label="toggle confirm password visibility"
                      edge="end"
                      onClick={() => setVisibility(prev => ({ ...prev, oldpassword: !prev.oldpassword }))}
                    >
                      {visibility.oldpassword ? <VisibilityOffIcon /> : <VisibilityIcon />}
                    </IconButton>
                  </InputAdornment>
                ),
              }}
            />
            <Typography sx={{ color: "#FA896B", fontSize: "12px" }}>{err}</Typography>
          </Grid>
          <Grid item xs={12} sm={6}>
            <CustomFormLabel htmlFor="text-npwd">New Password</CustomFormLabel>
            <CustomTextField
              id="text-npwd"
              placeholder="New Password"
              onChange={onhandlechange}
              variant="outlined"
              fullWidth
              name="newpassword"
              type={visibility.newpassword ? "text" : "password"}
              value={values.newpassword}
              error={errorState.newpassword}
              helperText={errorState.newpassword}
              InputProps={{
                endAdornment: (
                  <InputAdornment position="end">
                    <IconButton
                      sx={{
                        "&:focus": {
                          outline: "none",
                        },
                      }}
                      aria-label="toggle confirm password visibility"
                      edge="end"
                      onClick={() => setVisibility(prev => ({ ...prev, newpassword: !prev.newpassword }))}
                    >
                      {visibility.newpassword ? <VisibilityOffIcon /> : <VisibilityIcon />}
                    </IconButton>
                  </InputAdornment>
                ),
              }}
            />
          </Grid>
          <Grid item xs={12} sm={6}>
            <CustomFormLabel htmlFor="text-conpwd">Confirm Password</CustomFormLabel>
            <CustomTextField
              id="text-conpwd"
              placeholder="Confirm Password"
              onChange={onhandlechange}
              variant="outlined"
              fullWidth
              name="repeatpassword"
              type={visibility.repeatpassword ? "text" : "password"}
              value={values.repeatpassword}
              error={errorState.repeatpassword}
              helperText={errorState.repeatpassword}
              InputProps={{
                endAdornment: (
                  <InputAdornment position="end">
                    <IconButton
                      sx={{
                        "&:focus": {
                          outline: "none",
                        },
                      }}
                      aria-label="toggle confirm password visibility"
                      edge="end"
                      onClick={() => setVisibility(prev => ({ ...prev, repeatpassword: !prev.repeatpassword }))}
                    >
                      {visibility.repeatpassword ? <VisibilityOffIcon /> : <VisibilityIcon />}
                    </IconButton>
                  </InputAdornment>
                ),
              }}
            />
          </Grid>
          <Grid item xs={12}>
            <Box className="UpdateBtnWrapper">
              <Button
                onClick={handleclick}
                variant="contained"
                color="primary"
                sx={{
                  minWidth: "80px",
                  "&:focus": {
                    outline: "none",
                  },
                }}
                disabled={Object.values(errorState).some(err => err) || !values.oldpassword || !values.newpassword || !values.repeatpassword}
              >
                Update
              </Button>
            </Box>
          </Grid>
        </Grid>
      </form>
    </Box>
  );
}
